import { render, staticRenderFns } from "./IndividualList.vue?vue&type=template&id=5fc6238e&scoped=true"
import script from "./IndividualList.vue?vue&type=script&lang=js"
export * from "./IndividualList.vue?vue&type=script&lang=js"
import style0 from "./IndividualList.vue?vue&type=style&index=0&id=5fc6238e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc6238e",
  null
  
)

export default component.exports